export const environment = {
  production: true,
  appTitle: 'ΕΚΑΠΥ - Απογευματινά Χειρουργεία',
  appSubtitle:'Εθνική Κεντρική Αρχή Προμηθειών Υγείας',
  appTitleShort: 'ΕΚΑΠΥ - Απογ. Χειρ.',
  environmentName: 'production',
  ROOT_FOLDER: '/app',
  appUrl: 'https://epemvaseis.ekapy.gov.gr/app',
  apiUrl: 'https://epemvaseis.ekapy.gov.gr/api',
  appVersion: '1.1.0',
  useMock: false
};
